import { ApolloProvider } from '@apollo/client';
import { PropsWithChildren, useContext, useEffect, useMemo } from 'react';
import JWTContextCognito from '~/contexts/JWTContextCognito';
import { JWTContextType } from '~/types/auth';
import { createApolloClient, updateToken } from '~/utils/apollo-client';
import { updateGraphQLToken } from '~/utils/graphql-fetcher';

export const ApolloAuthProvider = ({ children }: PropsWithChildren<{}>) => {
  const authContext = JWTContextCognito;
  const jwtContext = useContext(authContext) as JWTContextType;

  const client = useMemo(() => createApolloClient(), []);

  useEffect(() => {
    updateToken(jwtContext?.token);
    // Also update token for React Query GraphQL fetcher
    updateGraphQLToken(jwtContext?.token);
  }, [jwtContext?.token]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
